import { useQuery } from '@tanstack/react-query';
import { AssignedUserObject } from 'data/v3/data-contracts';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiSuccessData,
  V3ApiError,
} from 'javascripts/services/v3ApiClient';

type UseGetAssignableUsersProps = {
  projectDbId: number;
};

type AssignUserData = {
  users: AssignedUserObject[];
};

type GetAssignableUsersResponse = V3ApiSuccessData<AssignUserData>;

const ASSIGNABLE_USERS_QUERY_KEY = 'ProjectTasksAssignableUsers';

export const useGetAssignableUsers = ({
  projectDbId,
}: UseGetAssignableUsersProps) => {
  const ASSIGNABLE_USERS_URL = `projects/${projectDbId}/tasks/assignable_users`;

  const { data, error } = useQuery<GetAssignableUsersResponse, V3ApiError>({
    queryKey: [ASSIGNABLE_USERS_QUERY_KEY, projectDbId],
    queryFn: async () => {
      const response = await request({
        url: ASSIGNABLE_USERS_URL,
      });
      return response.data;
    },
  });

  return {
    assignableUsers: data?.data?.users || [],
    error,
  };
};
